<template>
  <callout border-color="secondary-22" class="mb-3" :has-toggle="false">
    <div class="recommendation-container">
      <section-title
        class="mb-3 recommendation-container__section-title"
        container-class="recommendation-container__section-title__container"
        icon="fas fa-flag-alt"
        :title="proposalRequestStatus.title"
        title-class="recommendation-container__section-title__info"
      />
      <div class="align-items-center">
        <validation-observer ref="recommendEvaluation">
          <div class="mb-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="selectedStatusId"
                class="dropdown"
                :clearable="false"
                custom-error-msg="Favor seleccionar la recomendación."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="options"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div v-if="showComment" class="mr-md-4">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                v-model="comment"
                custom-error-msg="El comentario es requerido."
                :error="errors[0]"
                label="Razón:"
                :maxlength="3000"
                placeholder="Comentario"
                show-char-count
              />
            </validation-provider>
          </div>
        </validation-observer>
        <div class="d-flex justify-content-end pr-md-4">
          <action-button
            id="modal-btn-cancelar"
            i="fas fa-times-circle"
            variant="outline-danger mr-3"
            @click="cancel"
          >
            Cancelar
          </action-button>

          <action-button
            i="fa fa-save"
            variant="success px-3"
            @click="changeProposalStatus"
          >
            Guardar
          </action-button>
        </div>
      </div>
    </div>
  </callout>
</template>

<script>
import ActionButton from 'ActionButton';
import Callout from 'custom-callout';
import CustomDropDown from 'custom-drop-down';
import SectionTitle from 'SectionTitle';
import CustomTextArea from 'CustomTextArea';

import { changeProposalStatus } from '@/modules/serviceProposalHistory/api';
import alertMixin from 'utils/mixins/alert.mixin.js';
import { proposalRequestStatus } from '@/utils/constants/proposalRequestStatus';

export default {
  name: 'RecommendEvaluation',
  components: {
    ActionButton,
    Callout,
    CustomDropDown,
    SectionTitle,
    CustomTextArea,
  },
  mixins: [alertMixin],
  props: {
    proposalRequestId: {
      type: Number,
      default: () => 0,
    },
    proposalRequestStatus: {
      type: Object,
      required: true,
    },
    finalScore: {
      type: [String, Number],
      required: false,
      default: () => 0,
    },
  },
  data: () => ({
    selectedStatusId: null,
    options: null,
    actionMsg: null,
    customMsg: null,
    comment: null,
  }),
  computed: {
    confirmMsg() {
      return `¿Está seguro que <b>${this.actionMsg?.toUpperCase()}</b> ${this.customMsg.replace(
        '{verb}',
        'recomienda'
      )} la propuesta?`;
    },
    showComment() {
      return [
        proposalRequestStatus.NotRecommended,
        proposalRequestStatus.NotRecommendedInformation,
      ].includes(this.selectedStatusId?.id);
    },
    shouldValidateScore() {
      return [
        proposalRequestStatus.Recommended,
        proposalRequestStatus.RecommendedCondition,
      ].includes(this.selectedStatusId?.id);
    },
  },
  watch: {
    proposalRequestStatus: {
      immediate: true,
      handler(current) {
        const statusOptions = current.customOptions
          ? current.options
          : [
              { id: current.options[0], action: 'si', name: 'Si Recomienda' },
              { id: current.options[1], action: 'no', name: 'No Recomienda' },
            ];
        this.options = statusOptions;
      },
    },
  },
  methods: {
    cancel() {
      this.$emit('on-cancel');
    },
    async changeProposalStatus() {
      const isValid = await this.$refs.recommendEvaluation.validate();
      if (!isValid) return;

      this.actionMsg = this.selectedStatusId?.action || '';
      this.customMsg =
        this.selectedStatusId?.customMsg ||
        this.proposalRequestStatus.statusName;

      const answer = await this.ShowCancelModal(
        'Confirmación',
        this.confirmMsg,
        'Si',
        'No'
      );

      if (!answer) return;

      const payload = {
        comment: this.comment,
        finalScore: this.shouldValidateScore
          ? parseFloat(this.finalScore)
          : null,
      };

      await changeProposalStatus(
        this.proposalRequestId,
        this.selectedStatusId?.id,
        payload
      )
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            `La propuesta ${this.actionMsg} ha sido ${this.customMsg.replace(
              '{verb}',
              'recomendada'
            )} exitosamente.`,
            'success'
          );
          this.$emit('on-proposal-status-change');
        })
        .catch((err) => {
          if (err.response != null)
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.recommendation-container {
  padding-bottom: 1rem;

  .dropdown {
    @media screen and (min-width: 768px) {
      width: 45%;
    }
  }
  ::v-deep &__section-title {
    &__container {
      background: none;
      display: flex;
      align-items: center;

      .title-icon {
        font-size: 14px;
        color: map-get($colors, 'secondary-22');
      }

      .dot {
        background-color: map-get($colors, 'white');
        width: 28px;
        height: 28px;
      }
    }

    &__info {
      padding-left: 3px !important;
      color: map-get($colors, 'gray-7') !important;
    }

    @media screen and (min-width: 768px) {
      padding-left: 0px !important;
    }
  }
}
</style>
